export default __webpack_public_path__ + "static/media/steampad_doc.9037c654.pdf";